// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header-right[data-v-5ee2acc1] {\n  width: 80px;\n}", ""]);
// Exports
module.exports = exports;
